import * as fromDatatype from "../datatype-library";

export interface bl_fi_cashbook_imported_file_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_line_guid : fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    amt_debit: fromDatatype.NumericDatatypeInterface;
    amt_credit: fromDatatype.NumericDatatypeInterface;
    reference_num_1: fromDatatype.VarcharDatatypeInterface;
    reference_num_2: fromDatatype.VarcharDatatypeInterface;
    reference_num_3: fromDatatype.VarcharDatatypeInterface;
    reference_num_4: fromDatatype.VarcharDatatypeInterface;
    reference_num_5: fromDatatype.VarcharDatatypeInterface;
    date_txn_doc: fromDatatype.VarcharDatatypeInterface;
    date_create: fromDatatype.VarcharDatatypeInterface;
    date_update:fromDatatype.VarcharDatatypeInterface;
    date_posting:fromDatatype.VarcharDatatypeInterface;
    glcode_guid: fromDatatype.GuidDataFieldInterface;
    guid_cashbook:fromDatatype.GuidDataFieldInterface;
    guid_profit_center:fromDatatype.GuidDataFieldInterface;
    guid_segment:fromDatatype.GuidDataFieldInterface;
    guid_project: fromDatatype.GuidDataFieldInterface;
    guid_dimension:fromDatatype.GuidDataFieldInterface;
    guid_comp:fromDatatype.GuidDataFieldInterface;
    guid_branch:fromDatatype.GuidDataFieldInterface;
    label_json:fromDatatype.JsonDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;

}

export class bl_fi_cashbook_imported_file_line_RowClass implements bl_fi_cashbook_imported_file_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_line_guid : fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    amt_debit: fromDatatype.NumericDatatypeInterface;
    amt_credit: fromDatatype.NumericDatatypeInterface;
    reference_num_1: fromDatatype.VarcharDatatypeInterface;
    reference_num_2: fromDatatype.VarcharDatatypeInterface;
    reference_num_3: fromDatatype.VarcharDatatypeInterface;
    reference_num_4: fromDatatype.VarcharDatatypeInterface;
    reference_num_5: fromDatatype.VarcharDatatypeInterface;
    date_txn_doc: fromDatatype.VarcharDatatypeInterface;
    date_create: fromDatatype.VarcharDatatypeInterface;
    date_update:fromDatatype.VarcharDatatypeInterface;
    date_posting:fromDatatype.VarcharDatatypeInterface;
    glcode_guid: fromDatatype.GuidDataFieldInterface;
    guid_cashbook:fromDatatype.GuidDataFieldInterface;
    guid_profit_center:fromDatatype.GuidDataFieldInterface;
    guid_segment:fromDatatype.GuidDataFieldInterface;
    guid_project: fromDatatype.GuidDataFieldInterface;
    guid_dimension:fromDatatype.GuidDataFieldInterface;
    guid_comp:fromDatatype.GuidDataFieldInterface;
    guid_branch:fromDatatype.GuidDataFieldInterface;
    label_json:fromDatatype.JsonDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}